<script setup lang="ts">
import { useNotificationStore } from '@/stores/notification'
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-vue-next'

const notificationStore = useNotificationStore()
const iconMap = { success: CheckCircle, error: XCircle, warning: AlertTriangle, info: Info }
const colorMap = { success: 'bg-success-500/20 border-success-500/30 text-success-400', error: 'bg-danger-500/20 border-danger-500/30 text-danger-400', warning: 'bg-warning-500/20 border-warning-500/30 text-warning-400', info: 'bg-primary-500/20 border-primary-500/30 text-primary-400' }
const iconColorMap = { success: 'text-success-400', error: 'text-danger-400', warning: 'text-warning-400', info: 'text-primary-400' }
</script>

<template>
  <div class="fixed top-4 right-4 z-50 space-y-2 max-w-sm w-full pointer-events-none">
    <TransitionGroup name="toast">
      <div v-for="notification in notificationStore.notifications" :key="notification.id" class="pointer-events-auto rounded-xl border px-4 py-3 shadow-lg animate-slide-in" :class="colorMap[notification.type]">
        <div class="flex items-start gap-3">
          <component :is="iconMap[notification.type]" class="w-5 h-5 flex-shrink-0 mt-0.5" :class="iconColorMap[notification.type]" />
          <div class="flex-1 min-w-0">
            <p class="font-medium text-surface-100">{{ notification.title }}</p>
            <p v-if="notification.message" class="text-sm mt-0.5 text-surface-300">{{ notification.message }}</p>
          </div>
          <button @click="notificationStore.remove(notification.id)" class="flex-shrink-0 p-1 hover:bg-surface-700/50 rounded"><X class="w-4 h-4 text-surface-400" /></button>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active, .toast-leave-active { transition: all 0.3s ease; }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translateX(100%); }
.toast-move { transition: transform 0.3s ease; }
</style>
